// แผ่นงาน Excel การเลื่อนค่าตอบแทนพนักงานราชการ แยกกลุ่มตามสถานศึกษา/หน่วยงาน
//  orderSheet   = บัญชีรายชื่อแนบท้ายคำสั่ง (ที่ · ชื่อ-สกุล · ตำแหน่งเลขที่ · ตำแหน่ง · ประเภท · ค่าตอบแทนก่อนเลื่อน ·
//                 ร้อยละ · จำนวนเงินที่เลื่อน · ค่าตอบแทนตั้งแต่ 1 ต.ค. · หมายเหตุ)
//  compareSheet = เทียบก่อนบริหารวงเงิน (ร้อยละตามผลประเมินล้วน) กับหลังบริหารวงเงิน (เลื่อนจริง)
// groups: [{ name, rows: [{ full_name, id_position, name_postion, name_type_group, score, salary,
//            pre: {pct, amount, newSalary}, post: {pct, amount, newSalary}, note }] }]
import * as XLSX from "xlsx";

const MONEY = "#,##0";

function byPosition(a, b) {
  const pa = parseInt(a.id_position, 10);
  const pb = parseInt(b.id_position, 10);
  if (!isNaN(pa) && !isNaN(pb) && pa !== pb) return pa - pb;
  if (isNaN(pa) !== isNaN(pb)) return isNaN(pa) ? 1 : -1;
  return String(a.full_name).localeCompare(String(b.full_name), "th");
}

function posValue(v) {
  const n = Number(v);
  return v !== null && v !== undefined && v !== "" && Number.isFinite(n) && String(n) === String(v).trim() ? n : v || "";
}

// สร้าง sheet จากแถวหัว + กลุ่ม — moneyCols = ดัชนีคอลัมน์ที่จัดรูปแบบเงิน
function build({ titleRows, headRows, headMerges, groups, rowOf, moneyCols, widths }) {
  const nCol = widths.length;
  const aoa = [...titleRows.map(t => [t]), ...headRows];
  const merges = [
    ...titleRows.map((_, r) => ({ s: { r, c: 0 }, e: { r, c: nCol - 1 } })),
    ...headMerges.map(m => ({ s: { r: m.s.r + titleRows.length, c: m.s.c }, e: { r: m.e.r + titleRows.length, c: m.e.c } }))
  ];
  const moneyRows = [];
  groups.forEach(g => {
    if (!g.rows.length) return;
    merges.push({ s: { r: aoa.length, c: 0 }, e: { r: aoa.length, c: nCol - 1 } });
    aoa.push([g.name]);
    [...g.rows].sort(byPosition).forEach((r, i) => {
      moneyRows.push(aoa.length);
      aoa.push(rowOf(r, i + 1));
    });
    aoa.push([]);
  });
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  moneyRows.forEach(r => moneyCols.forEach(c => {
    const cell = ws[XLSX.utils.encode_cell({ r, c })];
    if (cell && cell.t === "n") cell.z = MONEY;
  }));
  ws["!merges"] = merges;
  ws["!cols"] = widths.map(wch => ({ wch }));
  return ws;
}

export function orderSheet(groups, { effectiveText, titleRows = [] }) {
  return build({
    titleRows,
    headRows: [["ที่", "ชื่อ-สกุล", "ตำแหน่งเลขที่", "ตำแหน่ง", "ประเภท", "อัตราค่าตอบแทนก่อนเลื่อน", "อัตราร้อยละที่ได้เลื่อน",
      "จำนวนเงินที่ได้รับการเลื่อนค่าตอบแทน", `ให้ได้รับค่าตอบแทน ตั้งแต่ ${effectiveText}`, "หมายเหตุ"]],
    headMerges: [],
    groups,
    rowOf: (r, i) => [i, r.full_name, posValue(r.id_position), r.name_postion, r.name_type_group, r.salary,
      r.post.pct, r.post.amount, r.post.newSalary, r.note || ""],
    moneyCols: [5, 7, 8],
    widths: [6, 28, 12, 42, 14, 14, 12, 16, 18, 30]
  });
}

export function compareSheet(groups, { titleRows = [] }) {
  return build({
    titleRows,
    headRows: [
      ["ที่", "ชื่อ-สกุล", "ตำแหน่งเลขที่", "ตำแหน่ง", "ประเภท", "ผลประเมิน (ฐานคะแนน)", "อัตราค่าตอบแทนก่อนเลื่อน",
        "ก่อนบริหารวงเงิน (ร้อยละตามผลประเมิน)", "", "", "หลังบริหารวงเงิน (เลื่อนจริง)", "", "", "ผลต่าง หลัง − ก่อน (บาท)", "หมายเหตุ"],
      ["", "", "", "", "", "", "", "ร้อยละ", "จำนวนเงินที่เลื่อน", "ค่าตอบแทนใหม่", "ร้อยละ", "จำนวนเงินที่เลื่อน", "ค่าตอบแทนใหม่", "", ""]
    ],
    headMerges: [
      ...[0, 1, 2, 3, 4, 5, 6, 13, 14].map(c => ({ s: { r: 0, c }, e: { r: 1, c } })),
      { s: { r: 0, c: 7 }, e: { r: 0, c: 9 } },
      { s: { r: 0, c: 10 }, e: { r: 0, c: 12 } }
    ],
    groups,
    rowOf: (r, i) => [i, r.full_name, posValue(r.id_position), r.name_postion, r.name_type_group,
      r.score > 0 ? r.score : "", r.salary,
      r.pre.pct, r.pre.amount, r.pre.newSalary, r.post.pct, r.post.amount, r.post.newSalary,
      r.post.amount - r.pre.amount, r.note || ""],
    moneyCols: [6, 8, 9, 11, 12, 13],
    widths: [6, 28, 12, 42, 14, 10, 14, 9, 12, 13, 9, 12, 13, 13, 36]
  });
}

// ร้อยละที่ได้เลื่อนจริงจากจำนวนเงิน (3 ตำแหน่ง)
export function pctOf(amount, salary) {
  return salary > 0 ? +((amount / salary) * 100).toFixed(3) : 0;
}
